/* Kohd lexicon: small words with simplified, non-nodal forms (Subroutine 2).
   They sit on the connection traces between word glyphs. Articles are not
   here: they modify the next word's charge node instead. */

export type ConstructType =
  | 'and' | 'or' | 'true' | 'false' | 'because' | 'so' | 'if' | 'ifThen'
  | 'thereIs' | 'unique' | 'fromTo'
  | 'you' | 'me' | 'youAll' | 'we' | 'them' | 'their';

export type Article = 'the' | 'a';

export interface LexiconEntry {
  type: ConstructType;
  plural?: true;
}

/** Book meaning of each symbol, used for labels and the legend. */
export const CONSTRUCT_LABELS: Record<ConstructType, string> = {
  and: 'and', or: 'or', true: 'true / is', false: 'false / not', because: 'because / since',
  so: 'so / this / causing', if: 'if', ifThen: 'if-then', thereIs: 'there is / there exists',
  unique: 'unique', fromTo: 'from-to', you: 'you', me: 'I / me', youAll: 'you all', we: 'we',
  them: 'them', their: 'their / theirs',
};

// Single words. "Them" and "their" have singular and plural forms; the plural
// English words (them, they, their) take the plural symbol.
export const LEXICON_WORDS: Record<string, LexiconEntry> = {
  and: { type: 'and' },
  or: { type: 'or' },
  true: { type: 'true' },
  is: { type: 'true' },
  false: { type: 'false' },
  not: { type: 'false' },
  because: { type: 'because' },
  since: { type: 'because' },
  so: { type: 'so' },
  this: { type: 'so' },
  causing: { type: 'so' },
  if: { type: 'if' },
  unique: { type: 'unique' },
  you: { type: 'you' },
  i: { type: 'me' },
  me: { type: 'me' },
  "y'all": { type: 'youAll' },
  we: { type: 'we' },
  us: { type: 'we' },
  him: { type: 'them' },
  her: { type: 'them' },
  it: { type: 'them' },
  them: { type: 'them', plural: true },
  they: { type: 'them', plural: true },
  his: { type: 'their' },
  hers: { type: 'their' },
  its: { type: 'their' },
  their: { type: 'their', plural: true },
  theirs: { type: 'their', plural: true },
};

// Two-word phrases with a single symbol.
export const LEXICON_PHRASES: Record<string, LexiconEntry> = {
  'there is': { type: 'thereIs' },
  'there are': { type: 'thereIs' },
  'there exists': { type: 'thereIs' },
  'you all': { type: 'youAll' },
};

export const ARTICLES: Record<string, Article> = { the: 'the', a: 'a', an: 'a' };
